import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import { hideModal, QBM_QUIZ } from '../../../modules/modals';
import { createQuiz } from './actions';
import FormContent from './components/FormContent';
import { checkAndUploadGeneralStatistic, checkAndUploadQuestions } from '../../../modules/questions';


class QbmQuiz extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : QBM_QUIZ});

  }

  getTitle = () => {
    const {formatMessage} = this.context
    let text = "frmTitleCreateQuize"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
  
    const { zIndex, selectedQuestionIds } = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <FormContent {...this.props} handleClose={this.handleClose} />
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({

});

const mapDispatchToProps = {
  hideModal,
  checkAndUploadGeneralStatistic,
  checkAndUploadQuestions,
}

export default connect(mapStateToProps, mapDispatchToProps)(QbmQuiz)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmQuiz/index.js